import { render, staticRenderFns } from "./ShadedSection.vue?vue&type=template&id=d9bb6ac6&scoped=true&functional=true&"
import script from "./ShadedSection.vue?vue&type=script&lang=js&"
export * from "./ShadedSection.vue?vue&type=script&lang=js&"
import style0 from "./ShadedSection.vue?vue&type=style&index=0&id=d9bb6ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "d9bb6ac6",
  null
  
)

export default component.exports